/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {Observable, timer} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CountDownService {
  getTimer(tick): Observable<number> {
    return timer(0, tick);
  }
}


